import {StepModel} from "./step";

export class ProjectModel extends StepModel{
    private _description: string = ''
    private _summary: string = ''
    private _technologiesUsed: Array<string> = []
    private _url: string = ''
    private _key: string = ''
    private _category: string = ''
    private _quality:number = 0


    get quality(): number {
        return this._quality;
    }

    set quality(value: number) {
        this._quality = value;
    }

    get description(): string {
        return this._description;
    }

    set description(value: string) {
        this._description = value;
    }

    get summary(): string {
        return this._summary;
    }

    set summary(value: string) {
        this._summary = value;
    }

    get technologiesUsed(): Array<string> {
        return this._technologiesUsed;
    }

    set technologiesUsed(value: Array<string>) {
        this._technologiesUsed = value;
    }


    get key(): string {
        return this._key;
    }

    set key(value: string) {
        this._key = value;
    }

    get url(): string {
        return this._url;
    }

    set url(value: string) {
        this._url = value;
    }


    get category(): string {
        return this._category;
    }

    set category(value: string) {
        this._category = value;
    }
}